// biome-ignore-all lint/suspicious/noArrayIndexKey: the session-date buttons are derived directly from request data on each render with a stable order.
// src/components/request/ActionSheetButtons.jsx
// -----------------------------------------------------------------------------
// The per-child "📄 Action Sheets" block — one dated button per confirmed
// session that has items for this child. Extracted from ShelterRequestView so it
// can also be dropped into the responder per-child card strip.
//
// Renders nothing when the child has no confirmed sessions.
//
// Props
//   child            — the child object
//   ci               — child index (passed back through onOpen)
//   sessionDates     — all confirmed session dates for the request (collectSessionDates)
//   reqState         — request state (stamped onto items)
//   uniformSuppliers — admin supplier list (for the Uniform item's next-steps type)
//   onOpen           — ({ ci, sessionDate }) => void  (opens the Action Sheet modal)

import { getSessionItems } from "../../services/actionSheets";
import { GLYPH } from "../../utils/glyphs";

export function ActionSheetButtons({
  child,
  ci,
  sessionDates,
  reqState,
  uniformSuppliers,
  onOpen,
}) {
  const opts = { reqState: reqState || "", uniformSuppliers };
  const childDates = (sessionDates || []).filter(function (sd) {
    return getSessionItems(child, sd, opts).length > 0;
  });
  if (childDates.length === 0) return null;

  return (
    <div style={{ borderTop: "1px solid #CFE0DE", paddingTop: 8, marginTop: 8 }}>
      <div
        className="action-sheet-flash"
        style={{
          fontSize: 13,
          fontWeight: 800,
          color: "#E65100",
          textTransform: "uppercase",
          letterSpacing: 0.6,
          marginBottom: 4,
        }}
      >
        📄 Action Sheets
      </div>
      {childDates.map(function (sd, si) {
        const items = getSessionItems(child, sd, opts);
        const label = items
          .map(function (it) {
            return it.type.split(" — ")[0];
          })
          .join(", ");
        return (
          <button
            key={si}
            type="button"
            onClick={function (e) {
              e.stopPropagation();
              onOpen({ ci: ci, sessionDate: sd });
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              width: "100%",
              background: "#FFFFFF",
              border: "1px solid #CFE0DE",
              borderRadius: 6,
              padding: "5px 10px",
              cursor: "pointer",
              fontFamily: "inherit",
              fontSize: 11,
              color: "#1A2E2B",
              marginBottom: 4,
              textAlign: "left",
            }}
          >
            <span style={{ fontSize: 13 }}>{GLYPH.printer}</span>
            <span style={{ fontWeight: 600, textDecoration: "underline" }}>
              {new Date(sd).toLocaleDateString("en-AU", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
            <span
              style={{
                color: "#607D79",
                fontSize: 10,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {`— ${label}`}
            </span>
          </button>
        );
      })}
    </div>
  );
}
